 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		13: 0,
 		6: 0,
 		9: 0,
 		11: 0,
 		71: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		13: 0,
 		6: 0,
 		9: 0,
 		11: 0,
 		71: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"vendors~route-MapView~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route~02240700","2":"vendors~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCameraSe~ffd0fef2","3":"route-MapView~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCo~837a17c8","4":"vendors~route-MapView~route-adminCameraSettings~route-album~route-habitat~route-highlights~route-hom~7e900d96","5":"vendors~route-MapView~route-album~route-habitat~route-highlights~route-home~route-myAlbum~route-schedule","16":"route-MapView","17":"route-TermsAndPrivacy","18":"route-account","19":"route-adminAdvertisements","20":"route-adminAnnouncements","21":"route-adminCameraInfo","22":"route-adminCameraSettings","23":"route-adminConfigurations","24":"route-adminHabitats","25":"route-adminOnlineUsersInfo","26":"route-adminPartners","27":"route-adminPlaylists","28":"route-adminTestNewModelsForAiKeeper","29":"route-adminUsers","30":"route-album","31":"route-emailVerify","32":"route-feed","33":"route-gift","34":"route-habitat","35":"route-habitats","36":"route-help","37":"route-highlights","38":"route-home","39":"route-importBundleUsers","40":"route-login","41":"route-myAlbum","42":"route-notFound","43":"route-notifications","44":"route-partnerDonation","45":"route-passwordReset","46":"route-plans","47":"route-profile","48":"route-redeem","49":"route-reports","50":"route-schedule","51":"route-signup","52":"route-socialLogin","53":"route-softReload","54":"route-talkSchedule","55":"route-welcome"}[chunkId]||chunkId) + ".chunk." + {"0":"fd1c8","1":"63a1f","2":"228ee","3":"a056f","4":"06114","5":"d0572","6":"4efb3","7":"54b55","8":"3bae9","9":"3b6e2","10":"c50bf","11":"db47c","12":"328bf","16":"9d157","17":"19a5f","18":"07f3c","19":"a915e","20":"5b117","21":"38c52","22":"49ed7","23":"e9bb0","24":"f8899","25":"b785b","26":"e2a87","27":"9e86d","28":"38d1e","29":"11a85","30":"316ca","31":"f8e4f","32":"9bb6f","33":"09651","34":"c078a","35":"51de3","36":"f8d0d","37":"f1e76","38":"90edb","39":"bcda7","40":"2e733","41":"57fc1","42":"6f6e2","43":"a7e60","44":"604b4","45":"8f74f","46":"cc3c8","47":"436ea","48":"fb605","49":"76fc3","50":"32749","51":"d9df7","52":"09bfc","53":"a77fe","54":"1b5f0","55":"d2df5","56":"3d5be","57":"a0ab7","58":"835e6","59":"0713a","60":"d2dc1","61":"5e869","62":"65635","63":"f5d8f","64":"7e1ea","65":"760c6","66":"0add9","67":"ecaf7","68":"bcec9","69":"ff001","70":"d933b","72":"d18ca","73":"1442b","74":"42fdc","75":"c2bfe","76":"2694b","77":"c2c3d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"3":1,"8":1,"10":1,"11":1,"12":1,"16":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"26":1,"27":1,"29":1,"30":1,"31":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"40":1,"41":1,"42":1,"44":1,"45":1,"46":1,"47":1,"48":1,"49":1,"50":1,"51":1,"54":1,"56":1,"57":1,"58":1,"59":1,"60":1,"61":1,"63":1,"65":1,"66":1,"67":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"1":"vendors~route-MapView~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route~02240700","2":"vendors~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCameraSe~ffd0fef2","3":"route-MapView~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCo~837a17c8","4":"vendors~route-MapView~route-adminCameraSettings~route-album~route-habitat~route-highlights~route-hom~7e900d96","5":"vendors~route-MapView~route-album~route-habitat~route-highlights~route-home~route-myAlbum~route-schedule","16":"route-MapView","17":"route-TermsAndPrivacy","18":"route-account","19":"route-adminAdvertisements","20":"route-adminAnnouncements","21":"route-adminCameraInfo","22":"route-adminCameraSettings","23":"route-adminConfigurations","24":"route-adminHabitats","25":"route-adminOnlineUsersInfo","26":"route-adminPartners","27":"route-adminPlaylists","28":"route-adminTestNewModelsForAiKeeper","29":"route-adminUsers","30":"route-album","31":"route-emailVerify","32":"route-feed","33":"route-gift","34":"route-habitat","35":"route-habitats","36":"route-help","37":"route-highlights","38":"route-home","39":"route-importBundleUsers","40":"route-login","41":"route-myAlbum","42":"route-notFound","43":"route-notifications","44":"route-partnerDonation","45":"route-passwordReset","46":"route-plans","47":"route-profile","48":"route-redeem","49":"route-reports","50":"route-schedule","51":"route-signup","52":"route-socialLogin","53":"route-softReload","54":"route-talkSchedule","55":"route-welcome"}[chunkId]||chunkId) + ".chunk." + {"0":"31d6c","1":"31d6c","2":"31d6c","3":"08f1a","4":"31d6c","5":"31d6c","6":"31d6c","7":"31d6c","8":"18e4e","9":"31d6c","10":"4cd1c","11":"17df8","12":"91d99","16":"ec2fe","17":"31d6c","18":"25649","19":"197d1","20":"197d1","21":"197d1","22":"0af25","23":"197d1","24":"abe1c","25":"31d6c","26":"5acf9","27":"197d1","28":"31d6c","29":"6c96c","30":"5f87a","31":"7990d","32":"31d6c","33":"362de","34":"4bf3a","35":"b6ffc","36":"3a1a1","37":"c5025","38":"2fde0","39":"31d6c","40":"1b2e4","41":"a29e2","42":"0e780","43":"31d6c","44":"1320c","45":"5255f","46":"cfcea","47":"8c877","48":"a3247","49":"576ae","50":"1698c","51":"3a45d","52":"31d6c","53":"31d6c","54":"ba6f8","55":"31d6c","56":"603c6","57":"1e8d3","58":"c51fe","59":"1fa4d","60":"429d0","61":"b2ca4","62":"31d6c","63":"c75d8","64":"31d6c","65":"65381","66":"91a66","67":"756f3","68":"31d6c","69":"31d6c","70":"31d6c","72":"31d6c","73":"31d6c","74":"31d6c","75":"31d6c","76":"31d6c","77":"31d6c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = "brot");
